import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import {faChevronLeft, faChevronRight, faXmark} from "@fortawesome/free-solid-svg-icons";
import {UserManagementService} from "../../../data-access/user-management.service";
import {BreadcrumbNavigation} from "../../../../shared/ui/breadcrumb/breadcrumb.component";

export interface Log {
  error_msg: string,
  timestamp: Date,
  allnew?: number,
  justroles?: number,
  nochange?: number,
  nouname?: number,
  noemail?: number
  errors?: number,
  badroles?: number
}
@Component({
    selector: 'autoImportLog',
    templateUrl: './autoImportLog.html',
    styleUrls: ['../userRoleAddEdit/userRoleAddEdit.css', '../importUsers/importUsers.css'],
    standalone: false
})
export class AutoImportLogComponent implements OnInit {
  constructor(private router: Router, private userService: UserManagementService) {
  }
  exitDialogOpen: boolean = false
  pageNumber: number = 0
  faChevronLeft = faChevronLeft
  faChevronRight = faChevronRight
  faXmark = faXmark
  maxPage: number = 0
  logs: Log[] = []
  detailLog: Log | null = null
  importLogDetail = false
  breadcrumbNavs: BreadcrumbNavigation[] = [{
    text: 'User Management',
    route: 'dashboard/UserManagement'
  }, {
    text: 'Import Users',
    route: 'dashboard/UserManagement/AllUsers/ImportUsers'
  }, {
    text: 'Automatic Roster Import',
    route: 'dashboard/UserManagement/AllUsers/ImportUsers/AutomaticImport'
  }]
  ngOnInit() {
    // TODO add a limit if we feel it is necessary
    this.userService.getAutoRosterLogs(this.pageNumber, 25).subscribe((response) => {
      if(response.success) {
        this.logs = response.result.items
        this.maxPage = Math.floor(response.result.totalcount / 25)
        console.log(this.maxPage)
      }
    })
  }

  navigate(nav:string) {
    this.router.navigate([nav])
  }

  decrementPage() {
    if(this.pageNumber !== 0) {
      this.pageNumber -= 1
    }
    this.userService.getAutoRosterLogs(this.pageNumber, 25).subscribe((response) => {
      if(response.success) {
        this.logs = response.result.items
        this.maxPage = response.result.totalcount / 25
      }
    })
  }
  incrementPage() {
    this.pageNumber += 1;
    this.userService.getAutoRosterLogs(this.pageNumber, 25).subscribe((response) => {
      if(response.success) {
        this.logs = response.result.items
        this.maxPage = Math.floor(response.result.totalcount / 25)
      }
    })
  }

  exitLogDetail() {
    this.importLogDetail = false
    this.detailLog = null
  }

  openLogDetail(log: Log) {
    this.importLogDetail = true
    this.detailLog = log
  }
}
